import type { BearingResult, BearingTrend, MotionReading } from './directionTypes';
import type { RssiProcessor } from './rssiProcessor';

/** Fuses RSSI trend with device heading to produce a display bearing and confidence. */
export function computeBearing(
  rssiProcessor: RssiProcessor,
  motion: MotionReading,
  peerId: string,
): BearingResult | null {
  const delta = rssiProcessor.getRssiDelta(peerId, 3);
  if (delta === null) {
    return null;
  }

  let trend: BearingTrend = 'stable';
  if (delta > 0.25) {
    trend = 'warmer';
  } else if (delta < -0.25) {
    trend = 'colder';
  }

  const confidence = Math.min(1, 0.25 + Math.min(1, Math.abs(delta) / 4));

  const h = motion.headingDeg;
  if (h === null) {
    return { bearingDeg: 0, confidence: confidence * 0.4, trend };
  }

  const bearingDeg = (360 - h + 360) % 360;
  return { bearingDeg, confidence, trend };
}
